import React from 'react'
import {
  Button,
  Card,
  Modal,
  Col,
  Form,
  Input,
  Row,
  Switch,
  Cascader,
  DatePicker,
  notification,
  InputNumber,
} from 'antd'
import {connect} from 'react-redux'

import {fetchCategories, editCategoryImage} from 'appRedux/actions/Coupons'

const FormItem = Form.Item

class Basic extends React.Component {
  constructor(props) {
    super(props)
  }
  state = {
    id: '',
    visible: false,
    name: '',
    order: 0,
    validateStatusNombre: '',
    helpNombre: '',
  }

  showModal = () => {
    this.setState({
      visible: true,
      id: this.props.recording.id,
      name: this.props.recording.name,
      order: this.props.recording.sortOrder,
    })
  }

  handleCancel = e => {
    this.setState({
      visible: false,
    })
    this.props.fetchCategories()
    this.setState({visible: false})
    if (this.state.name == '') {
      this.setState({validateStatusNombre: '', helpNombre: ''})
    }
  }

  onNotification = (type, value) => {
    if (type == 'success') {
      notification[type]({
        message: 'Éxito',
        description: 'La categoría se ha editado con éxito.',
      })
    } else {
      notification[type]({
        message: 'Error',
        description: value || 'Ha ocurrido un error al editar la categoría.',
      })
    }
  }

  onChangeS = checked => {
    if (checked) {
      this.setState({active: 1})
    } else {
      this.setState({active: 0})
    }
  }

  onHandleClick = event => {
    event.preventDefault()
    let {name} = this.state

    if (name) {
      this.props.editCategoryImage(this.state, () => {
        this.props.fetchCategories()
      })
      this.onNotification('success')
    } else {
      if (this.state.name == '') {
        this.setState({
          validateStatusNombre: 'error',
          helpNombre: 'Nombre es un campo obligatorio.',
        })
      } else {
        this.setState({validateStatusNombre: '', helpNombre: ''})
      }

      let messageError = 'Rellene el campos obligatorio.'
      this.onNotification('error', messageError)
    }
  }

  handlChangeImage = selectorFiles => {
    const file = selectorFiles[0]
    this.setState({imageUrl: file})
  }

  render() {
    return (
      <div>
        <Button type="primary" onClick={this.showModal}>
          <i className="icon icon-edit" />
        </Button>
        <Modal
          afterClose={() => this.props.fetchCategories()}
          okText="Editar"
          cancelText="Salir"
          title=""
          visible={this.state.visible}
          onOk={this.onHandleClick}
          onCancel={this.handleCancel}
        >
          <Card className="gx-card" title="Editar categoría">
            <form onSubmit={this.onHandleClick}>
              <Row>
                <Col lg={12} md={12} sm={12} xs={24}>
                  <FormItem
                    label="Categoría *:"
                    labelCol={{xs: 9, sm: 9, lg: 9, md: 9}}
                    validateStatus={this.state.validateStatusNombre}
                    help={this.state.helpNombre}
                  >
                    <Input
                      required
                      placeholder="Nombre de la categoría"
                      value={this.state.name}
                      onChange={event => {
                        this.setState({
                          name: event.target.value,
                        })

                        if (event.target.value != '') {
                          this.setState({
                            validateStatusNombre: '',
                            helpNombre: '',
                          })
                        } else {
                          this.setState({
                            validateStatusNombre: 'error',
                            helpNombre: 'Nombre es un campo obligatorio.',
                          })
                        }
                      }}
                    />
                  </FormItem>
                </Col>

                <Col lg={12} md={12} sm={12} xs={24}>
                  <FormItem
                    label="Orden *:"
                    labelCol={{xs: 9, sm: 9, lg: 9, md: 9}}
                  >
                    <InputNumber
                      min={0}
                      max={1000}
                      defaultValue={this.state.order}
                      onChange={value => this.setState({order: value})}
                      style={{width: 160}}
                    />
                  </FormItem>
                </Col>

                <Col lg={12} md={12} sm={12} xs={24}>
                  <Card type="inner" title="Foto de la tienda">
                    <FormItem
                      label="Tamaño: (200 x 200 px)"
                      labelCol={{xs: 24, sm: 24, lg: 24, md: 24}}
                    />
                    <input
                      type="file"
                      onChange={event => {
                        this.handlChangeImage(event.target.files)
                      }}
                    />
                  </Card>
                </Col>
              </Row>
            </form>
          </Card>
        </Modal>
      </div>
    )
  }
}

function mapStateToProps({categories}) {
  return {
    categories,
  }
}

export default connect(
  mapStateToProps,
  {fetchCategories, editCategoryImage},
)(Basic)



// WEBPACK FOOTER //
// ./src/routes/main/Cupons/Category/ModalEdit.js